<ng-container *ngIf="prices">
    <div class="card-sub-header-content">
        <div class="filter-container">
            <div class="filter-traveller">
                <multiselect *ngIf="travellers"
                             [fieldConfig]="filtersFieldsConfig.traveller"
                             [options]="filtersOptions.traveller"
                             [labelCustom]="filtersConfig.traveller.defaultLabel"
                             [disabled]="isFilterDisabled"></multiselect>
            </div>
        </div>
    </div>

    <price-table [prices]="prices">
    </price-table>

    <div *ngIf="!prices" class="noInformation">{{ labels.noPrice }}</div>
</ng-container>